<!-- We hardcode to true because passing in true somehow makes inputNumber and dropdown required fields with validators -->
<app-input-wrapper
  [label]="label"
  [required]="true"
  [errorMessage]="errorMessage"
  [touched]="touched"
  [disabled]="disabled">

  <div class="input-plus-picker-container">
    <p-inputNumber
      [(ngModel)]="numericValue"
      [disabled]="disabled || unknownDate"
      (onBlur)="calculateValue()"
      [class.error]="touched && errorMessage" />

    <p-dropdown
      [options]="dateOptions"
      [(ngModel)]="unitValue"
      [disabled]="disabled || unknownDate"
      (onChange)="calculateValue()"
      i18n-placeholder="@@inputPlusPicker.select"
      placeholder="Select..."
      appendTo="body">
    </p-dropdown>

    <span i18n="@@inputPlusPicker.ago">ago</span>
  </div>

  <app-checkbox
    i18n-label="@@inputPlusPicker.unknownDate"
    label="Unknown date?"
    [(ngModel)]="unknownDate"
    (onCheckboxChange)="onCheckboxChange($event)"
    [class.error]="touched && errorMessage"
    [disabled]="disabled">
  </app-checkbox>

</app-input-wrapper>